/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Arrow from 'src/assets/arrow-left.svg';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { useActions } from 'src/hooks/useActions';
import { RegularButton } from 'pg-ui-library';

import NotificationsTable from 'src/components/notifications-table';
import NotificationModal from '../notifications/add-notification-modal/index';
import {
  MenuWrapper,
  Background,
  ButtonWrapper,
  DropdownWrapper,
  Menu,
  MenuTop,
  BackWrapper,
  BackAnchor,
  ArrowBack,
  PageTitle,
} from './styles';

interface NotificationsProps {
  open: boolean;
}

const Notifications: React.FC<NotificationsProps> = ({ open }) => {
  const [display, setDisplay] = useState<boolean>(open);
  const [modalOpen, setModalOpen] = useState(false);

  const { data } = useTypedSelector(state => state.notifications);
  const { t } = useTranslation();
  const { getNotifications } = useActions();

  useEffect(() => {
    getNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // call only once on mount

  useEffect(() => {
    setDisplay(open);
  }, [open]);

  const handleModalSubmit = () => {
    getNotifications();
    setModalOpen(false);
  };

  return (
    <MenuWrapper hide={display}>
      <Menu>
        <MenuTop>
          <BackWrapper>
            <BackAnchor onClick={() => setDisplay(false)}>
              <ArrowBack src={Arrow} />
            </BackAnchor>
            <PageTitle>{t('notifications.pageTitle')}</PageTitle>
          </BackWrapper>
          <ButtonWrapper>
            <RegularButton type="button" onClick={() => setModalOpen(true)}>
              Add Notification
            </RegularButton>

            <NotificationModal open={modalOpen} onClose={() => setModalOpen(false)} onSubmit={handleModalSubmit} />
            <RegularButton>{t('notifications.button')}</RegularButton>
          </ButtonWrapper>
        </MenuTop>
        <DropdownWrapper>
          <NotificationsTable />
        </DropdownWrapper>
      </Menu>
      <Background onClick={() => setDisplay(false)} />
    </MenuWrapper>
  );
};

export default Notifications;
